<script setup>
import { useI18n } from 'vue-i18n';
import { watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

const { locale } = useI18n();
const route = useRoute();


// Vérifie si une langue est déjà stockée au chargement
onMounted(() => {
  const savedLang = localStorage.getItem('site-language');
  if (savedLang) {
    locale.value = savedLang;
  }
});
const isHome = computed(() => route.path === '/');

// Pour que le bouton reste actif si on change ailleurs dans le site
watch(locale, (newLang) => {
  localStorage.setItem('site-language', newLang);
});


</script>

<template>
  <div class="language-switcher" :class="{ homepage: isHome }">
   <select v-model="locale">
      <option v-for="lang in ['fr', 'en', 'de']" :key="lang" :value="lang">
        {{ lang.toUpperCase() }}
      </option>
    </select>
  </div>
</template>

<style scoped>
.language-switcher {
  display: flex;
}
select {
  background: transparent;
  color: #4F4F4F;
  border: 1px solid white;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  border-radius: 4px;
}

/* HOME PAGE : texte et bordures blanches */
.language-switcher.homepage select {
  color: white;
  border-color: white;
}
option {
  color: black; /* les options doivent être lisibles */
}

/* Responsive */
@media (max-width: 768px) {
  .language-switcher {
    font-size: 1rem;
  }
  select {
  
  color: #4F4F4F !important;
 
}
}
</style>
